import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, shallowRef} from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'YellowRadioButton',
  props: /*@__PURE__*/_mergeModels({
  value: String
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const props = __props
const [model] = _useModel(__props, "modelValue")
const active = computed(() => model.value == props.value);
const onClick = () => {
  model.value = props.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio-button", {active: active.value}]),
    onClick: onClick
  }, null, 2))
}
}

})